import { IAction } from "@selas/models";
import { createEntityReducer } from "@selas/state-management";
import { AxiosError, AxiosResponse } from "axios";
import { Reducer } from "redux";
import { initialOpportunityState, IOpportunityState } from "..";

import Endpoint from "../../services/api/endpoint";
import { IOpportunity } from "../../utils/types/models";

const opportunityReducer: Reducer<IOpportunityState, IAction> = (state: IOpportunityState = initialOpportunityState, action: IAction) => {
	switch (action.type) {
		case "REQUEST_POST_" + Endpoint.MyOpportunitiesList: {
			state = {
				...state,
				isListLoading: true,
				listLoadError: null
			};
			break;
		}
		case "REQUEST_SUCCESS_POST_" + Endpoint.MyOpportunitiesList: {
			const payload: { response: AxiosResponse } = action.payload as { response: AxiosResponse };
			if (payload && payload.response && payload.response.data) {
				let results: IOpportunity[] = payload.response.data.data;
				if (payload.response.data.group) {
					results = payload.response.data.group;
				}
				state = {
					...state,
					list: results || [],
					totalCount: payload.response.data.total || 0
				};
			}
			break;
		}
		case "REQUEST_FAILURE_POST_" + Endpoint.MyOpportunitiesList: {
			const payload: { error: AxiosError } = action.payload as { error: AxiosError };
			state = {
				...state,
				listLoadError: payload.error
			};
			break;
		}
		case "REQUEST_END_POST_" + Endpoint.MyOpportunitiesList: {
			state = {
				...state,
				isListLoading: false
			};

			break;
		}
		case "CLEAR_POST_" + Endpoint.MyOpportunitiesList: {
			state = {
				...state,
				list: [],
				totalCount: 0,
				isListLoading: true,
				listLoadError: null
			};
			break;
		}
		case "REQUEST_POST_" + Endpoint.CreateFromProject:
			state = {
				...state,
				isAdding: true,
				addedEntity: null,
				addError: null
			};
			break;
		case "REQUEST_SUCCESS_POST_" + Endpoint.CreateFromProject: {
			const payload: { response: AxiosResponse } = action.payload as { response: AxiosResponse };
			if (payload && payload.response && payload.response.data) {
				state = {
					...state,
					addedEntity: payload.response.data
				};
			}
			break;
		}
		case "REQUEST_FAILURE_POST_" + Endpoint.CreateFromProject: {
			const payload: { error: AxiosError } = action.payload as { error: AxiosError };
			state = {
				...state,
				addError: payload.error
			};
			break;
		}
		case "REQUEST_END_POST_" + Endpoint.CreateFromProject:
			state = {
				...state,
				isAdding: false
			};
			break;
		case "CLEAR_POST_" + Endpoint.CreateFromProject:
			state = {
				...state,
				isAdding: false,
				addedEntity: null,
				addError: null
			};
			break;

		default:
			return state;
	}
	return state;
};

export default createEntityReducer<IOpportunity, IOpportunityState>(Endpoint.Opportunities, Endpoint.OpportunitiesList, opportunityReducer);
